module.exports = __webpack_public_path__ + "img/personal_student_wrong_noexplain.43ec3e0f.svg";